
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"fill":"none","viewBox":"0 0 17 17"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{staticClass:"i-stroke",attrs:{"stroke":"#798f8f","stroke-linecap":"round","stroke-linejoin":"round","d":"m11.5 14.5.027-10.51a1.54 1.54 0 0 0-.41-1.054 1.36 1.36 0 0 0-.99-.436h-3.2c-.37 0-.727.157-.99.436-.262.28-.41.658-.41 1.053L5.5 14.5m-2.512-9h11.2c.773 0 1.312.741 1.312 1.564v5.947c0 .822-.627 1.489-1.4 1.489H2.9c-.773 0-1.4-.667-1.4-1.49V7.065c0-.823.714-1.564 1.487-1.564"}})])
          )
        }
      }
    